module.exports = __webpack_public_path__ + "img/store.2523c7c.svg";